import { Routes } from '@angular/router';
import { PaymentSuccessComponent } from './registration/payment-success/payment-success.component';
import { PaymentRosterReturnComponent } from './registration/payment-roster-return/payment-roster-return.component';
import { TournamentPublicComponent } from './tournament/tournament-public.component';
import { AboutComponent } from './about/about.component';
import { RulesRegulationsComponent } from './rules-regulations/rules-regulations.component';
import { RefundPolicyComponent } from './refund-policy/refund-policy.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { teamSectionRoutes } from './teams/team.routes';
import { playerSectionRoutes } from './players/player.routes';
import { TeamInviteAcceptComponent } from './players/team-invite-accept/team-invite-accept.component';
import { TenantFeatureGuard } from './tenant/tenant-feature.service';
import { TenantPageVisibilityGuard } from './tenant/tenant-page-visibility.service';

export const appRoutes: Routes = [
  { path: '', loadChildren: () => import('./home/home.routes').then(m => m.default) },
  ...playerSectionRoutes,
  ...teamSectionRoutes,
  {
    path: 'player-content',
    children: [
      {
        path: 'players',
        children: [
          { path: '', redirectTo: '/my-dashboard/admin/users', pathMatch: 'full' },
          { path: 'team/:teamId', redirectTo: '/team/:teamId/roster', pathMatch: 'full' },
        ],
      },
      {
        path: 'add-player',
        children: [
          { path: '', redirectTo: '/add-player', pathMatch: 'full' },
          { path: 'team/:teamId', redirectTo: '/add-player/team/:teamId', pathMatch: 'full' },
        ],
      },
      {
        path: 'multiassign-players',
        children: [
          { path: 'team/:teamId', redirectTo: '/team/:teamId/roster/browse', pathMatch: 'full' },
        ],
      },
      {
        path: 'import-players',
        children: [
          { path: '', redirectTo: '/import-players', pathMatch: 'full' },
          { path: 'team/:teamId', redirectTo: '/import-players/team/:teamId', pathMatch: 'full' },
        ],
      },
      {
        path: 'edit-player',
        children: [
          {
            path: ':playerId',
            children: [
              { path: '', redirectTo: '/my-dashboard/admin/users', pathMatch: 'full' },
              {
                path: 'team/:teamId',
                redirectTo: '/my-dashboard/admin/users',
                pathMatch: 'full',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: 'team-content',
    children: [
      { path: 'teams', redirectTo: '/teams', pathMatch: 'full' },
      { path: 'add-team', redirectTo: '/add-team', pathMatch: 'full' },
      { path: 'import-teams', redirectTo: '/import-teams', pathMatch: 'full' },
      { path: 'edit-team/:teamId', redirectTo: '/edit-team/:teamId', pathMatch: 'full' },
    ],
  },
  { path: 'my-dashboard', loadChildren: () => import('./my/my.routes').then(m => m.default) },
  { path: 'payments', redirectTo: '/my-dashboard/admin/payments', pathMatch: 'full' },
  { path: 'schedule-content', loadChildren: () => import('./schedule/schedule.routes').then(m => m.default), canActivate: [TenantFeatureGuard], data: { tenantModule: 'schedule' } },
  { path: 'auth', loadChildren: () => import('./auth/auth.routes').then(m => m.default) },
  {
    path: 'profile',
    loadComponent: () => import('./my/my-shell.component').then(m => m.MyShellComponent),
    children: [
      { path: '', loadChildren: () => import('./profile/profile.routes').then(m => m.default) },
    ],
  },
  { path: 'league', loadChildren: () => import('./league/league.routes').then(m => m.default), canActivate: [TenantFeatureGuard, TenantPageVisibilityGuard], data: { tenantModule: ['schedule', 'statistics', 'standings', 'playoffs'], tenantPage: 'league' } },
  { path: 'tournament', component: TournamentPublicComponent, canActivate: [TenantFeatureGuard, TenantPageVisibilityGuard], data: { tenantModule: 'settings', tenantPage: 'tournament' } },
  { path: 'schedule', redirectTo: '/league/schedule', pathMatch: 'full' },
  { path: 'results', redirectTo: '/league/results', pathMatch: 'full' },
  { path: 'rankings', redirectTo: '/league/standings', pathMatch: 'full' },
  { path: 'playoffs', redirectTo: '/league/playoffs', pathMatch: 'full' },
  { path: 'leaderboard', redirectTo: '/league/leaderboard', pathMatch: 'full' },
  { path: 'division-content', loadChildren: () => import('./divisions/division.routes').then(m => m.default), canActivate: [TenantFeatureGuard], data: { tenantModule: 'settings' } },
  { path: 'season-content', loadChildren: () => import('./seasons/seasons.routes').then(m => m.default), canActivate: [TenantFeatureGuard], data: { tenantModule: 'settings' } },
  { path: 'payment-content', loadChildren: () => import('./payments/payment.routes').then(m => m.default), canActivate: [TenantFeatureGuard], data: { tenantModule: 'payments' } },
  { path: 'payroll-content', loadChildren: () => import('./payroll/payroll.routes').then(m => m.default), canActivate: [TenantFeatureGuard], data: { tenantModule: 'payroll' } },
  { path: 'register', loadChildren: () => import('./registration/registration.routes').then(m => m.default), canActivate: [TenantFeatureGuard], data: { tenantModule: 'registration' } },
  { path: 'about-us', component: AboutComponent, canActivate: [TenantFeatureGuard, TenantPageVisibilityGuard], data: { tenantModule: 'public_site', tenantPage: 'about_us' } },
  { path: 'rules-regulations', component: RulesRegulationsComponent, canActivate: [TenantFeatureGuard, TenantPageVisibilityGuard], data: { tenantModule: 'public_site', tenantPage: 'rules_regulations' } },
  { path: 'refund-policy', component: RefundPolicyComponent, canActivate: [TenantFeatureGuard], data: { tenantModule: 'public_site' } },
  { path: 'team-invite/:token', component: TeamInviteAcceptComponent },
  { path: 'payment/return', component: PaymentSuccessComponent },
  { path: 'payment/roster-return', component: PaymentRosterReturnComponent },
  { path: '**', component: NotFoundComponent }
];
